<template>
    <div>
        <!-- 重置密码 -->
        <Modal v-model="resetPasswordModal" :title="$t('permission_configuration_management.register.ResetPassword')" :mask-closable="false">
             <Form ref="resetPasswordForm" :model="resetPasswordForm" :rules="ruleValidate" :label-width="120">
                <div v-show="currentTip">
                    <!-- 当前密码 -->
                    <FormItem :label="$t('permission_configuration_management.user.currentPassword')" prop="currentPassword">
                        <Input v-model="resetPasswordForm.currentPassword" style="width:300px;" type="password"></Input>
                    </FormItem>

                    <!-- 新密码 -->
                    <FormItem :label="$t('permission_configuration_management.user.newPassword')" prop="password">
                        <Input v-model="resetPasswordForm.password" style="width:300px;" type="password"></Input>
                    </FormItem>

                    <!-- 确认密码 -->
                    <FormItem :label="$t('permission_configuration_management.user.confirmPassword')" prop="confirmPassword">
                        <Input v-model="resetPasswordForm.confirmPassword" style="width:300px;" type="password"></Input>
                    </FormItem>
                </div>
                <div v-show="errorTip">
                    <Alert type="warning" show-icon>
                        {{$t('permission_configuration_management.register.Warning')}}
                        <template slot="desc">{{$t('permission_configuration_management.register.ResetTip')}}</template>
                    </Alert>
                </div>
            </Form>
            <div slot="footer">
                <Button @click="resetPasswordReset('resetPasswordForm')">{{$t('permission_configuration_management.register.Cancel')}}</Button>
                <span v-show="currentTip">
                    <Button type="primary" @click="resetPasswordSubmit('resetPasswordForm')">{{$t('permission_configuration_management.register.Reset')}}</Button>
                </span>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        name: 'ResetPassword',
        data() {
            // 当前密码是否正确
            var validPasswordRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.user.reset({
                    "id": self.id,
                    "currentPassword": this.resetPasswordForm.currentPassword
                })
                .then(res => {
                    if (res.status == 200) {
                        this.currentTip=true;
                        this.errorTip=false;
                        callback();
                    }
                })
                .catch(err => {
                    // 当前密码不正确 您还有几次机会
                    if (err.status == 400&&err.data!=false) {
                        this.currentTip=true;
                        this.errorTip=false;
                        this.count=err.data;
                        callback(new Error(this.$t('permission_configuration_management.user.currentPasswordIncorrectRemaining', {count: this.count})));
                    }else if(err.status == 400&&err.data==false){
                        this.errorTip=true;
                        this.currentTip=false;
                    }
                })
            };
            const pwdValidate = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t('permission_configuration_management.user.passwordRequired')));
                } else {
                    callback();
                }
            };
            const pwdCheckValidate = (rule, value, callback) => {
                if (this.resetPasswordForm.password != '' && value == '') {
                    callback(new Error(this.$t('permission_configuration_management.user.confirmPasswordRequired')));
                } else if (this.resetPasswordForm.password != this.resetPasswordForm.confirmPassword) {
                    callback(new Error(this.$t('permission_configuration_management.user.passwordMismatch')));
                } else {
                    callback();
                }
            };
            return {
                id:null,
                currentTip:false,
                errorTip:false,
                count:null,
                resetPasswordModal: false,//重置密码
                resetPasswordForm:{
                    currentPassword:'',
                    password:''
                },
                ruleValidate: {
                    currentPassword: [
                        {required: true, message: this.$t('permission_configuration_management.user.pleaseInputCurrentPassword'), trigger: 'blur'},
                        // {validator: validPasswordRepeatedCheck, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, validator: pwdValidate, trigger: 'blur'},
                        {
                            message: this.$t('permission_configuration_management.user.passwordRule'),
                            pattern: '^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$',
                            trigger: 'blur'
                        }
                    ],
                    confirmPassword: [
                        {required: true, validator: pwdCheckValidate, trigger: 'blur'},
                        {
                            message: this.$t('permission_configuration_management.user.passwordRule'),
                            pattern: '^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,20}$',
                            trigger: 'blur'
                        }
                    ]
                }
            }
        },
        mounted: function () {
        },
        methods: {
            getData:function(row,index) {
                this.resetPasswordForm.currentPassword='';
                this.$refs['resetPasswordForm'].resetFields();
                this.id=row.id;
                this.resetPasswordModal = true;
                this.currentTip=true;
                // 检查是否还有修改密码机会
                this.$api.user.checkPasswordChangesAllowed("id",row.id)
                .then(res => {
                    if(res.status==200){
                        this.errorTip=false;
                        this.currentTip=true;
                    }
                })
                .catch(err => {
                    if(err.status == 400){
                        this.errorTip=true;
                        this.currentTip=false;
                    }
                })
            },
            /*****************************重置密码*************************/
            resetPasswordSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var currentDate={
                            "id": this.id,
                            "currentPassword": this.resetPasswordForm.currentPassword,
                            "password": this.resetPasswordForm.password
                        };
                        this.$Message.destroy();
                        this.$api.user.reset(currentDate)
                        .then(res => {
                            setTimeout(() => {
                                this.$refs[name].resetFields();
                                this.$Message.success(this.$t('permission_configuration_management.user.changeSuccess'));
                                this.currentTip=true;
                                this.errorTip=false;
                                this.resetPasswordModal = false;
                                this.resetPasswordForm.currentPassword='';
                            },1000);
                        })
                        .catch(err => {
                            // 当前密码不正确 您还有几次机会
                            if (err.status == 400&&err.data!=false) {
                                this.currentTip=true;
                                this.errorTip=false;
                                this.count=err.data;
                                this.$Message.error({
                                    content: this.$t('permission_configuration_management.user.currentPasswordIncorrectRemaining', {count: this.count}),
                                    duration: 0,
                                    closable: true
                                });
                            }else if(err.status == 400&&err.data==false){
                                this.errorTip=true;
                                this.currentTip=false;
                            }
                        })
                    } else {
                        this.$Message.error(this.$t('permission_configuration_management.user.changeFail'));
                    }
                });
            },
            resetPasswordReset: function (name) {
                this.resetPasswordModal = false;
                this.$refs[name].resetFields();
                this.$Message.destroy()
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/user/ResetPassword.vue